import firedux from '../firedux'
import store, {dispatch} from '../store'

import {USERS_ENDPOINT} from '../../config/constants'

export default (role) => {
  if (typeof(role) !== 'number') return

  const state = store.getState()

  if (state.get('currentUser') && state.getIn(['currentUser', 'uid'])) {
    const ENDPOINT = `${USERS_ENDPOINT}/${state.getIn(['currentUser', 'uid'])}/role`
    firedux.ref.child(ENDPOINT).set(role)
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/current_user_role.js
 **/